/* =========================================================
   KORUMAO
   GLOBAL JAVASCRIPT
   File: assets/korumao.js
   ========================================================= */

document.addEventListener('DOMContentLoaded', () => {


  /* =======================================================
     01 — SCROLL REVEALS
     ======================================================= */

  const revealElements =
    document.querySelectorAll(
      '[data-koru-reveal]'
    );


  if (
    revealElements.length &&
    'IntersectionObserver' in window
  ) {

    const revealObserver =
      new IntersectionObserver(
        (entries) => {

          entries.forEach((entry) => {

            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add(
              'is-visible'
            );

            revealObserver.unobserve(
              entry.target
            );

          });

        },
        {
          threshold: 0.12
        }
      );


    revealElements.forEach((element) => {

      revealObserver.observe(element);

    });

  }


  else {

    revealElements.forEach((element) => {

      element.classList.add(
        'is-visible'
      );

    });

  }


});